module.exports = __webpack_public_path__ + "media/src/images/excel_on-75f49a98cf1e33bde644e66291f0508a.png";